import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-gap: 12px;
`

export const RadioButtonContainer = styled.div<{
  checked: boolean
}>`
  /* Button Text */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;

  /* identical to box height, or 100% */
  letter-spacing: 0.01em;

  /* primary/grey/grey-text-light */
  color: #8c8c8c;

  border-radius: 8px;
  /* primary/grey/grey-white */
  background: #fafafa;
  /* primary/grey/grey */
  border: 1px solid #bdbdbd;

  padding: 20px 0 20px 24px;
  cursor: pointer;

  ${({ checked = false }) =>
    checked &&
    `
    /* primary/yellow/yellow-100 */
    background: #FFF9D5;
    /* primary/yellow/yellow-500 */
    border: 1px solid #FFD130;
    /* primary/grey/grey-text */
    color: #333333;
  `}
`
